import React, { useRef, useEffect, useState } from 'react';
import { clsx } from '@pushpay/styles';
import { useStyles, imageLoadListener, useImageLoaded } from './shared';

const PreloadedImage = props => {
  const {
    src,
    onImageDisplayed,
    alt,
    className: classNameProp,
    classes: classesProp,
    resizeOnLoad,
    width,
    height,
    'data-pp-at-target': targetId,
    ...rest
  } = props;
  const elem = useRef(null);
  const classes = useStyles(classesProp, {
    width,
    height
  });
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    const imageLoader = document.createElement('img');
    const loadListener = imageLoadListener(imageLoader, elem, src, setIsLoaded, resizeOnLoad, onImageDisplayed);

    if (src) {
      imageLoader.addEventListener('load', loadListener);
      imageLoader.src = src;
    }

    return () => {
      imageLoader.removeEventListener('load', loadListener);
    };
  }, [src]);
  useImageLoaded(elem, isLoaded, targetId || '');
  const className = clsx(classes.root, classNameProp, isLoaded ? classes.loaded : classes.loading);
  return /*#__PURE__*/React.createElement("img", Object.assign({
    ref: elem,
    src: "",
    alt: alt,
    className: className,
    width: width,
    height: height,
    "data-pp-at-target": targetId
  }, rest));
};

export default PreloadedImage;